/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgPhoneOff(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <g>
        <path
          fill='currentColor'
          fillRule='evenodd'
          d='M23.53.47a.75.75 0 010 1.06L11.746 13.315a15.28 15.28 0 002.225 1.654l.859-.86.003-.002a2.785 2.785 0 012.9-.62c.854.32 1.741.54 2.645.66h.007a2.77 2.77 0 012.365 2.746V19l.003.25c.004.201.009.44 0 .646-.015.334-.065.72-.233 1.104a2.75 2.75 0 01-2.767 1.637l-.014-.001a20.535 20.535 0 01-8.954-3.185 20.034 20.034 0 01-2.915-2.26l-6.34 6.34A.75.75 0 01.47 22.47l22-22a.75.75 0 011.06 0zM10.684 14.377l-1.752 1.752a18.518 18.518 0 002.66 2.058l.006.004a19.038 19.038 0 008.295 2.953 1.25 1.25 0 001.252-.745c.065-.149.099-.33.11-.57.007-.164.004-.306 0-.47-.002-.106-.005-.222-.005-.359v-2.117a1.27 1.27 0 00-1.072-1.25 13.59 13.59 0 01-2.97-.74l-.002-.001a1.286 1.286 0 00-1.317.28l-.002.001-1.267 1.267a.75.75 0 01-.9.122 16.994 16.994 0 01-3.036-2.185zM7.944 3.052a1.25 1.25 0 00-.827-.302H4.11a1.25 1.25 0 00-1.244 1.356 19.04 19.04 0 002.953 8.296.75.75 0 01-1.258.816 20.54 20.54 0 01-3.187-8.957l-.001-.013A2.75 2.75 0 014.109 1.25h2.998a2.75 2.75 0 012.746 2.365v.007c.12.904.34 1.792.66 2.646l-.703.262.702-.264a2.75 2.75 0 01-.619 2.901l-.003.003-1.27 1.27a.75.75 0 11-1.06-1.06l1.267-1.267.001-.002a1.25 1.25 0 00.28-1.317v-.002a13.59 13.59 0 01-.741-2.97 1.25 1.25 0 00-.422-.77z'
        />
      </g>
      <defs>
        <clipPath id='phone-off_svg__clip0_126_10332'>
          <path fill='#fff' d='M0 0h24v24H0z' />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgPhoneOff;
